import type { Environment } from '@rcs/data-schema';
import { DEFAULT_GROUND_COLORS, type EnvironmentLook } from '@rcs/renderer';

/** 環境（保存データの形式）から、3D の背景の見た目を作る。 */
export function toEnvironmentLook(environment: Environment): EnvironmentLook {
  return {
    skyTop: environment.sky.top,
    skyHorizon: environment.sky.horizon,
    fogDensity: environment.fog.density,
    ground: environment.terrain.material,
    groundColor: environment.terrain.color ?? DEFAULT_GROUND_COLORS[environment.terrain.material],
    timeOfDay: environment.lighting.timeOfDay,
    sunIntensity: environment.lighting.sunIntensity,
    sunAzimuth: environment.lighting.sunAzimuth,
    sunElevation: environment.lighting.sunElevation,
  };
}
